import { BaseRestApiEndpoint, ERestApiMethod } from "utils/api";

type TInput = {
  id: number;
};

export type TOutput = {
  status: string;
  msg: string;
  msg_bottom?: unknown; // TODO
  renter: {
    created_at: Date;
    name: string;
    birthdate: Date;
    address: string;
  };
  police: Array<unknown>; // TODO
  insolvency_register: Array<{
    detail_url: string;
    applications_count: number;
    address: string;
  }>;
  insolvency_register_sk: Array<unknown>; // TODO
  debtor_zpmvcr: Array<unknown>; // TODO
  debtor_zpvzp: Array<unknown>; // TODO
  executor_board: Array<unknown>; // TODO
  executor: Array<unknown>; // TODO
  ispis_cee: Array<{
    date: Date;
    file_number: string;
    executor_office: string;
  }>;
  ispis_cee_sk: Array<unknown>; // TODO
  ispis_cee_warning: string;
  ispis_cee_pdf_link?: string;
  is_ispis_cee: boolean;
  is_spinner: boolean;
};

export default class GetCreditCheckExternalReportApiEndpoint extends BaseRestApiEndpoint<
  TInput,
  TOutput
> {
  method = ERestApiMethod.GET;
  allowedStatusCodes = [500, 409];

  resolveUri({ id }: TInput): string {
    return `/fe-api/credit-check/external-report/${id}`;
  }
}
